import { AuthorizationService, AxiosInstance, DataAccessService, EventService, ExportService, PowerBiService } from '@price-for-profit/micro-services-common';
import { ServiceContext } from 'shared/providers';
import { FuturePriceService, NotificationService } from 'shared/services';
import { CustomEventService } from 'shared/services/custom-event-service';
import { CustomExportService } from 'shared/services/custom-export-service';
import { EmailAddressService } from 'shared/services/email-address-service';
import { EventExportService } from 'shared/services/event-export-service';
import LambdaService from 'shared/services/lambda-service';
import { AppConfig } from 'shared/types';

interface ICreateServiceContextProps {
    appConfig: AppConfig;
    httpClient: AxiosInstance;
    backendHttpClient: AxiosInstance;
    environment: string;
}

export function createServiceContext({
    appConfig,
    httpClient,
    backendHttpClient,
    environment,
}: ICreateServiceContextProps): ServiceContext {
    const eventService = new EventService(httpClient);
    const customEventService = new CustomEventService(eventService, environment);
    const exportService = new CustomExportService(backendHttpClient);
    const exportMSService = new ExportService(httpClient);
    const eventExportService = new EventExportService(exportMSService);
    const emailAddressService = new EmailAddressService(backendHttpClient);
    const notificationService = new NotificationService(customEventService, emailAddressService);
    const authService = new AuthorizationService(httpClient);
    const powerBiService = new PowerBiService(httpClient);
    const lambdaService = new LambdaService(httpClient);
    const dataAccessService = new DataAccessService(httpClient);
    const futurePriceService = new FuturePriceService(dataAccessService);

    return {
        appConfig,
        eventService,
        exportService,
        eventExportService,
        exportMSService,
        notificationService,
        emailAddressService,
        authService,
        powerBiService,
        lambdaService,
        dataAccessService,
        futurePriceService
    }
}